import request from '@/utils/request'
const BASE_URL = '/pdd/waybills'

export default {
  waybill(data) {
    return request({
      url: BASE_URL + '/waybill',
      method: 'post',
      data
    })
  },
  batchWaybill(data) {
    return request({
      url: BASE_URL + '/batchwaybill',
      method: 'post',
      data
    })
  },
  batchReprint(data) {
    return request({
      url: BASE_URL + '/batchreprint',
      method: 'post',
      data
    })
  },
  cancelwaybill(data) {
    return request({
      url: BASE_URL + '/cancelwaybill',
      method: 'post',
      data
    })
  },
}